import { Link } from "react-router-dom";
import { Logo } from "./Logo";

// Prompt 16 — small unobtrusive footer with links to the three public
// legal pages. Rendered on the landing/login/register pages and inside
// `Layout.jsx` for every authenticated page.
export default function Footer() {
  return (
    <footer
      className="border-t border-neutral-200 bg-white py-4 px-6 text-xs text-neutral-500 flex flex-wrap items-center justify-between gap-3"
      data-testid="site-footer"
    >
      <div className="flex items-center gap-3">
        <Link to="/" data-testid="footer-logo">
          <Logo className="h-6" testid="footer-logo-img" />
        </Link>
        <div data-testid="footer-copyright">
          © 2026 Lingua Franca LLC
        </div>
      </div>
      <nav className="flex items-center gap-4">
        <Link to="/help" className="hover:text-neutral-900" data-testid="footer-help">
          Help
        </Link>
        <Link to="/terms" className="hover:text-neutral-900" data-testid="footer-terms">
          Terms
        </Link>
        <Link to="/privacy" className="hover:text-neutral-900" data-testid="footer-privacy">
          Privacy
        </Link>
        <Link to="/contact" className="hover:text-neutral-900" data-testid="footer-contact">
          Contact
        </Link>
      </nav>
    </footer>
  );
}
